import { useCallback, useEffect } from 'react';
import useRouter from 'use-react-router';
import { useDispatch, useSelector } from 'react-redux';

import { selectListDefaultOptions } from 'store/lists/selectors';
import { fetchListOptions } from 'store/lists/actions';
import Table from './Table';
import paths from 'routing/routes/_paths';

const PurchasingStores = () => {
  const dispatch = useDispatch();
  const organizationList = useSelector(state => selectListDefaultOptions(state, 'organizations'));
  const { history, location, match } = useRouter();
  const { path, params } = match;
  const { organizationId } = params;
  const isUnlinked = path?.includes('unlinked');

  const initOrganizations = useCallback(async () => {
    await dispatch(fetchListOptions('organizations'));
  }, [dispatch]);

  useEffect(() => {
    if (organizationList?.length) {
      if (isUnlinked && !organizationId) {
        history.replace({
          pathname: `${paths.enums.purchasing_stores_unlinked}/${organizationList[0]?.id}`
        });
      }
    } else {
      initOrganizations();
    }
  }, [history, initOrganizations, isUnlinked, location.pathname, organizationId, organizationList]);

  return (isUnlinked && organizationId) || !isUnlinked ? <Table key={organizationId} /> : null;
};

export default PurchasingStores;
